var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPersonOffFill = function SvgPersonOffFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.075 21.9 17.15 20H6q-.824 0-1.413-.587A1.93 1.93 0 0 1 4 18v-.8q0-.85.437-1.562.438-.713 1.163-1.088 1.125-.575 2.287-.925a16.4 16.4 0 0 1 2.363-.525L2.075 4.925a.93.93 0 0 1-.288-.712A1.02 1.02 0 0 1 2.1 3.5q.3-.3.712-.3.413 0 .713.3l16.975 17q.3.3.3.7t-.3.7-.712.3a.97.97 0 0 1-.713-.3m-.675-7.35q.725.35 1.15 1.063.425.712.45 1.537l-3.35-3.35q.45.175.888.35.437.175.862.4m-4.2-3.2L8.65 5.8a4.1 4.1 0 0 1 1.45-1.325A3.9 3.9 0 0 1 12 4q1.65 0 2.825 1.175T16 8q0 1.025-.475 1.9a4.1 4.1 0 0 1-1.325 1.45"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPersonOffFill);
export { ForwardRef as ReactComponent };